<div class="card mt-lg-0 bg-tertiary mb-3">
  <div [ngClass]="{ 'card-body-account': accountView }">
    <div class="d-flex flex-column flex-lg-row justify-content-lg-between align-items-center">
      <ng-container *ifScreenSize="screenSize.Mobile">
        <fgbcl-date-range-picker
          class="w-100"
          [(startDate)]="transactionStartDate"
          [(endDate)]="transactionEndDate"
        ></fgbcl-date-range-picker>
      </ng-container>
      <ng-container *ifScreenSize="screenSize.Desktop">
        <fgbcl-date-range-picker [(startDate)]="transactionStartDate" [(endDate)]="transactionEndDate"></fgbcl-date-range-picker>
      </ng-container>
      <button type="button" class="search-button fw-bold d-block border-0 text-white bg-primary" (click)="search()">
        Search
      </button>
    </div>
  </div>
</div>

<fgb-transaction-list
  *ngIf="selectedValues"
  [startDate]="selectedValues.start"
  [endDate]="selectedValues.end"
  [memberId]="memberId"
  [transactionType]="selectedValues.type"
></fgb-transaction-list>
